// Dependencies
import { useTranslation } from 'react-i18next';
import React, { FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
// Icons
import Close from '@mui/icons-material/Close';
// Actions
import { updateCircuitNameLocale } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { updateCircuitInfoErrors } from './redux/reducer';
import { FormHelperText } from '@mui/material';

const CircuitNameLocale: FC = (): ReactElement => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const locales = useSelector((state: AppState) => state.locale.list);
    const current_locale = useSelector((state: AppState) => state.locale.current_locale);
    const circuit_name_locales = useSelector((state: AppState) => state.circuit.circuit_name_locales);
    const circuit_info_errors = useSelector((state: AppState) => state.circuitSlice.circuit_info_errors);
    const onCategoryNameLocaleChange = (id: number) => (event: { target: { value: any; }; }) => {
        dispatch(updateCircuitNameLocale(id, event.target.value));
        dispatch(updateCircuitInfoErrors({ ...circuit_info_errors, name: '' }));
    };
    const onEmptyCategoryNameLocale = (id: number) => () => {
        dispatch(updateCircuitNameLocale(id, ''));
        dispatch(updateCircuitInfoErrors({ ...circuit_info_errors, name: '' }));
    };
    return (
        <Grid item xs={ 12 }>
            {
                current_locale !== null && locales && locales.map((locale) => {
                    if (locale.id === current_locale) {
                        return (
                            <FormControl key={ `category-name-locale-${locale.language_code}` } required fullWidth variant={ 'outlined' } error={!!circuit_info_errors.name}>
                                <InputLabel htmlFor={ `category-name-locale-${locale.language_code}` }>{ t('shared.name') } ({locale.language_code})</InputLabel>
                                <OutlinedInput
                                    id={ `category-name-locale-${locale.language_code}` }
                                    type={ 'text' }
                                    error={!!circuit_info_errors.name}
                                    onChange={ onCategoryNameLocaleChange(locale.id) }
                                    label={ `${t('shared.name')} (${locale.language_code})` }
                                    value={ circuit_name_locales[locale.id] ? circuit_name_locales[locale.id] : '' }
                                    autoComplete={ 'off' }
                                    endAdornment={ <Close className={ 'ft-user-closeIcon' } onClick={ onEmptyCategoryNameLocale(locale.id) }/> }
                                />
                                <FormHelperText>{circuit_info_errors.name}</FormHelperText>
                            </FormControl>
                        );
                    }
                })
            }
        </Grid>
    );
};

export default CircuitNameLocale;